<template>
  <div>
    <div class="main-banner home-hero">
      <header class="header-area">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <nav class="main-navigation">
                <div class="logo">
                  <a href="/index.html">
                    <img src="/assets/images/logomobigames.png" alt=""/>
                  </a>
                </div>

                <div class="search-bar">
                  <div class="container">
                    <div class="row">
                      <!-- ***** Search End ***** -->
                      <div class="search-wrap">
                        <div class="search-input">
                          <form id="search" action="#">
                            <input type="text" placeholder="Type Something" id="searchText" name="searchKeyword"
                                   onkeypress="handle"/>
                            <i class="fa fa-search"></i>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ***** Menu End ***** -->
              </nav>
            </div>
          </div>
        </div>
      </header>

      <div class="main-banner-content">
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-6 d-flex align-items-center">
              <div class="header-text">
                <h4>Welcome</h4>
                <h1>ALL THE KINGS ARE FIGHTING</h1>
                <h6>Hurry to join in the greatest Valorant tournament of all time. Fight till the end and get the
                  reward</h6>
              </div>
            </div>

            <div class="col-12 col-lg-6">
              <div class="header-image"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="welcome">
      <div class="alert-wrapper">
        <div class="alertcontent">
          <div class="popup-heading">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            <h2>Action Required</h2>
          </div>

          <div class="popup-text">
            <p>
              Please switch to <span class="saflogo"><img src="/assets/images/saf-logo.png" alt="mmh"/></span> mobile
              data to continue.
            </p>
          </div>

          <div class="popup-cta">
            <a href="mobigames.html">Click Here To Continue </a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import {mapActions} from "vuex";
import Swal from "sweetalert2";

const xml2js = require('xml2js');

export default {
  name: "dashboard-default",
  data() {
    return {

      payload: {
        msisdn: "",
        utm:
            {
              click_id: "",
              affiliate_id: "",
            },
        timestamp: "",
        redirect_url: "https://ke.mobifreegames.com/",
        product_id: "",
      },
    };
  },
  components: {},

  created() {

    let pid = this.$route.params.pid
    let aid = this.$route.params.aid

    this.payload.product_id = pid
    this.payload.utm.affiliate_id = aid

    const urlParams = new URLSearchParams(window.location.search);
    const paramNames = ['cid', 'click_id', 'CLICKID', 'CLICK_ID', 'clickID', 'clickId'];
    // Loop through the array and check each parameter name
    let utmClickId;
    for (const paramName of paramNames) {
      // Convert the parameter name to lowercase
      const lowercaseParamName = paramName.toLowerCase();
      // Check if the lowercase parameter name exists in the URL parameters
      if (urlParams.has(lowercaseParamName)) {
        // Retrieve the value of the parameter
        utmClickId = urlParams.get(lowercaseParamName);
        // Break the loop once a value is found
        break;
      }
    }

    this.payload.utm.click_id = utmClickId

    // Get the referrer URL
    // const referrerUrl = document.referrer;
    // Print the referrer URL to the console
    // console.log('Referrer URL:', referrerUrl);
    // if (referrerUrl !== null || referrerUrl !== "") {
    //   this.payload.redirect_url = referrerUrl ?? "https://ke.mobifreegames.com/"
    // }

  },

  mounted() {
    this.setHeaders()
  },
  methods: {
    ...mapActions(["getHeaders", "mtActivate",]),

    //
    async setHeaders() {
      try {
        const response = await this.getHeaders();

        const cleanResp = await this.parseXml(response.message);

        const status = cleanResp[0];

        if (status === 0 || status === "0") {
          console.log("1 :", cleanResp[0]);
          console.log("2 :", cleanResp[1]);
          console.log("3 :", cleanResp[2]);
          this.payload.msisdn = cleanResp[2]
          await this.activateMT()
        } else {
          console.log("cleanResp Headers failed with error:", cleanResp[0]);

          await this.showModalAfterDelay()
        }
      } catch (error) {
        console.error("Error during getting UserProfile:", error);
      }
    },

    //
    async parseXml(xmlString) {
      return new Promise((resolve, reject) => {
        const parser = new xml2js.Parser("")
        parser.parseString(xmlString, (err, result) => {
          if (err) {
            reject(err);
            return;
          }

          let responseCode = "1"
          let responseRefId = ""
          let msisdnHash = ""

          responseCode = result['SOAP-ENV:Envelope']['SOAP-ENV:Body'][0]['ns0:ServiceResponse'][0]['ns0:ResponseHeader'][0]['ns0:ResponseCode'][0];

          if (responseCode === 0 || responseCode === "0") {
            responseRefId = result['SOAP-ENV:Envelope']['SOAP-ENV:Body'][0]['ns0:ServiceResponse'][0]['ns0:ResponseHeader'][0]['ns0:ResponseRefId'][0];
            msisdnHash = result['SOAP-ENV:Envelope']['SOAP-ENV:Body'][0]['ns0:ServiceResponse'][0]['ns0:Body'] ? result['SOAP-ENV:Envelope']['SOAP-ENV:Body'][0]['ns0:ServiceResponse'][0]['ns0:Body'][0]['ns1:MsisdnResponse'][0]['ns1:MsisdnHash'][0] : null;
          }

          resolve([responseCode, responseRefId, msisdnHash]);

        });
      });

    },

    //
    async activateMT() {

      let app = this
      app.isLoading = true

      try {

        this.payload.timestamp = Date.now()
        const response = await this.mtActivate(this.payload);

        console.log("mtActivate::", JSON.stringify(response))

        app.isLoading = false
        if (response.status === 200||response.status === "200") {
          // await this.$router.push({name: 'Step2'})

          console.log("mt Redirect:: ", JSON.stringify(response.data.url))
          // Redirect to the specified URL
          // this.$router.replace(response.data.url);
          window.location.replace(response.data.url);
        } else {

          await Swal.fire({
            icon: 'error',
            // title: 'Failed!',
            text: response.message,
            showCancelButton: false,
            confirmButtonText: 'Ok',
          });

        }

      } catch (error) {
        console.error("Catch Error activateMT:", error);
      }

      app.isLoading = false
    },

    //
    async showModalAfterDelay() {
      setTimeout(() => {
        document.getElementById("welcome").style.display = "block";
        // eslint-disable-next-line no-undef
        $("body").css("overflow", "hidden");
      }, 500);

    },

    //

  }
};
</script>
